import { useQuery } from '@tanstack/react-query';

import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { queryClient } from 'config/queryClient';
import { QueryKey } from 'types/query';

export const useGetJobImprovedQuery = (dbId: number | null | undefined) => {
  return useQuery(
    [QueryKey.useGetJobImproved, dbId && { db_id: dbId }],
    async () => {
      if (!dbId) throw Error('Vacancy id is required');

      return fetchJobImproved(dbId);
    },
    { retry: 0, enabled: !!dbId },
  );
};

useGetJobImprovedQuery.fetchQuery = async (dbId: number) => {
  return queryClient.fetchQuery([QueryKey.useGetJobImproved, { db_id: dbId }], () => fetchJobImproved(dbId));
};

export const fetchJobImproved = async (dbId: number) => {
  const { data } = await reachoutClient.getJobImproved(dbId);

  return data;
};
